import { useServices } from "contexts/ServiceContext";

const useTranslation = () => useServices().I18NService.t;

export default useTranslation;
